/* eslint-disable */

// Generated from /Users/pyt/Downloads/AudienceLogic.g4 by ANTLR 4.7.1
// jshint ignore: start
import antlr4 from 'antlr4';

import { AudienceLogicListener } from './AudienceLogicListener';

const grammarFileName = 'AudienceLogic.g4';

const serializedATN = [
  '\u0003\u608b\ua72a\u8133\ub9ed\u417c\u3be7\u7786\u5964',
  '\u0003\t*\u0004\u0002\t\u0002\u0004\u0003\t\u0003\u0004\u0004\t\u0004',
  '\u0004\u0005\t\u0005\u0003\u0002\u0003\u0002\u0003\u0002\u0003\u0002',
  '\u0005\u0002\u000f\n\u0002\u0003\u0003\u0003\u0003\u0003\u0003\u0003',
  '\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0005\u0003\u0019',
  '\n\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003',
  '\u0003\u0003\u0007\u0003!\n\u0003\f\u0003\u000e\u0003$\u000b\u0003\u0003',
  '\u0004\u0003\u0004\u0003\u0005\u0003\u0005\u0003\u0005\u0002\u0003\u0004',
  '\u0006\u0002\u0004\u0006\b\u0002\u0003\u0003\u0002\u0003\u0004\u0002',
  '*\u0002\u000e\u0003\u0002\u0002\u0002\u0004\u0018\u0003\u0002\u0002',
  "\u0002\u0006%\u0003\u0002\u0002\u0002\b'\u0003\u0002\u0002\u0002\n",
  '\u000b\u0005\u0004\u0003\u0002\u000b\f\u0007\u0002\u0002\u0003\f\u000f',
  '\u0003\u0002\u0002\u0002\r\u000f\u0003\u0002\u0002\u0002\u000e\n\u0003',
  '\u0002\u0002\u0002\u000e\r\u0003\u0002\u0002\u0002\u000f\u0003\u0003',
  '\u0002\u0002\u0002\u0010\u0011\b\u0003\u0001\u0002\u0011\u0012\u0007',
  '\u0006\u0002\u0002\u0012\u0013\u0005\u0004\u0003\u0002\u0013\u0014\u0007',
  '\u0007\u0002\u0002\u0014\u0019\u0003\u0002\u0002\u0002\u0015\u0016\u0007',
  '\u0005\u0002\u0002\u0016\u0019\u0005\u0004\u0003\u0006\u0017\u0019\u0005',
  '\b\u0005\u0002\u0018\u0010\u0003\u0002\u0002\u0002\u0018\u0015\u0003',
  '\u0002\u0002\u0002\u0018\u0017\u0003\u0002\u0002\u0002\u0019"\u0003',
  '\u0002\u0002\u0002\u001a\u001b\f\u0005\u0002\u0002\u001b\u001c\u0007',
  '\u0003\u0002\u0002\u001c!\u0005\u0004\u0003\u0006\u001d\u001e\f\u0004',
  '\u0002\u0002\u001e\u001f\u0007\u0004\u0002\u0002\u001f!\u0005\u0004',
  '\u0003\u0005 \u001a\u0003\u0002\u0002\u0002 \u001d\u0003\u0002\u0002',
  '\u0002!$\u0003\u0002\u0002\u0002" \u0003\u0002\u0002\u0002"#\u0003',
  '\u0002\u0002\u0002#\u0005\u0003\u0002\u0002\u0002$"\u0003\u0002\u0002',
  "\u0002%&\t\u0002\u0002\u0002&\u0007\u0003\u0002\u0002\u0002'(\u0007",
  '\b\u0002\u0002(\t\u0003\u0002\u0002\u0002\u0006\u000e\u0018 "',
].join('');

const atn = new antlr4.atn.ATNDeserializer().deserialize(serializedATN);

const decisionsToDFA = atn.decisionToState.map((ds, index) => new antlr4.dfa.DFA(ds, index));

const sharedContextCache = new antlr4.atn.PredictionContextCache();

const literalNames = [null, "'&'", "'|'", "'!'", "'('", "')'"];

const symbolicNames = [null, 'AND', 'OR', 'NOT', 'LPAREN', 'RPAREN', 'IDENTIFIER', 'WS'];

const ruleNames = ['parse', 'expression', 'binary', 'literal'];

class AudienceLogicParser extends antlr4.Parser {
  constructor(input) {
    super(input);
    this._interp = new antlr4.atn.ParserATNSimulator(this, atn, decisionsToDFA, sharedContextCache);
    this.ruleNames = ruleNames;
    this.literalNames = literalNames;
    this.symbolicNames = symbolicNames;
    return this;
  }

  get atn() {
    return atn;
  }

  parse() {
    const localctx = new ParseContext(this, this._ctx, this.state);
    this.enterRule(localctx, 0, AudienceLogicParser.RULE_parse);
    try {
      this.state = 12;
      this._errHandler.sync(this);
      switch (this._input.LA(1)) {
        case AudienceLogicParser.NOT:
        case AudienceLogicParser.LPAREN:
        case AudienceLogicParser.IDENTIFIER:
          this.enterOuterAlt(localctx, 1);
          this.state = 8;
          this.expression(0);
          this.state = 9;
          this.match(AudienceLogicParser.EOF);
          break;
        case AudienceLogicParser.EOF:
          this.enterOuterAlt(localctx, 2);

          break;
        default:
          throw new antlr4.error.NoViableAltException(this);
      }
    } catch (re) {
      if (re instanceof antlr4.error.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  expression(_p) {
    if (_p === undefined) {
      _p = 0;
    }
    const _parentctx = this._ctx;
    const _parentState = this.state;
    let localctx = new ExpressionContext(this, this._ctx, _parentState);
    let _prevctx = localctx;
    const _startState = 2;
    this.enterRecursionRule(localctx, 2, AudienceLogicParser.RULE_expression, _p);
    try {
      this.enterOuterAlt(localctx, 1);
      this.state = 22;
      this._errHandler.sync(this);
      switch (this._input.LA(1)) {
        case AudienceLogicParser.LPAREN:
          localctx = new ParenthesisExpressionContext(this, localctx);
          this._ctx = localctx;
          _prevctx = localctx;

          this.state = 15;
          this.match(AudienceLogicParser.LPAREN);
          this.state = 16;
          this.expression(0);
          this.state = 17;
          this.match(AudienceLogicParser.RPAREN);
          break;
        case AudienceLogicParser.NOT:
          localctx = new NotExpressionContext(this, localctx);
          this._ctx = localctx;
          _prevctx = localctx;
          this.state = 19;
          this.match(AudienceLogicParser.NOT);
          this.state = 20;
          this.expression(4);
          break;
        case AudienceLogicParser.IDENTIFIER:
          localctx = new LiteralExpressionContext(this, localctx);
          this._ctx = localctx;
          _prevctx = localctx;
          this.state = 21;
          this.literal();
          break;
        default:
          throw new antlr4.error.NoViableAltException(this);
      }
      this._ctx.stop = this._input.LT(-1);
      this.state = 32;
      this._errHandler.sync(this);
      let _alt = this._interp.adaptivePredict(this._input, 3, this._ctx);
      while (_alt != 2 && _alt != antlr4.atn.ATN.INVALID_ALT_NUMBER) {
        if (_alt === 1) {
          if (this._parseListeners !== null) {
            this.triggerExitRuleEvent();
          }
          _prevctx = localctx;
          this.state = 30;
          this._errHandler.sync(this);
          const la_ = this._interp.adaptivePredict(this._input, 2, this._ctx);
          switch (la_) {
            case 1:
              localctx = new BinaryExpressionContext(this, new ExpressionContext(this, _parentctx, _parentState));
              localctx.left = _prevctx;
              this.pushNewRecursionContext(localctx, _startState, AudienceLogicParser.RULE_expression);
              this.state = 24;
              if (!this.precpred(this._ctx, 3)) {
                throw new antlr4.error.FailedPredicateException(this, 'this.precpred(this._ctx, 3)');
              }
              this.state = 25;
              localctx.op = this.match(AudienceLogicParser.AND);
              this.state = 26;
              localctx.right = this.expression(4);
              break;

            case 2:
              localctx = new BinaryExpressionContext(this, new ExpressionContext(this, _parentctx, _parentState));
              localctx.left = _prevctx;
              this.pushNewRecursionContext(localctx, _startState, AudienceLogicParser.RULE_expression);
              this.state = 27;
              if (!this.precpred(this._ctx, 2)) {
                throw new antlr4.error.FailedPredicateException(this, 'this.precpred(this._ctx, 2)');
              }
              this.state = 28;
              localctx.op = this.match(AudienceLogicParser.OR);
              this.state = 29;
              localctx.right = this.expression(3);
              break;
          }
        }
        this.state = 34;
        this._errHandler.sync(this);
        _alt = this._interp.adaptivePredict(this._input, 3, this._ctx);
      }
    } catch (error) {
      if (error instanceof antlr4.error.RecognitionException) {
        localctx.exception = error;
        this._errHandler.reportError(this, error);
        this._errHandler.recover(this, error);
      } else {
        throw error;
      }
    } finally {
      this.unrollRecursionContexts(_parentctx);
    }
    return localctx;
  }

  binary() {
    const localctx = new BinaryContext(this, this._ctx, this.state);
    this.enterRule(localctx, 4, AudienceLogicParser.RULE_binary);
    let _la = 0; // Token type
    try {
      this.enterOuterAlt(localctx, 1);
      this.state = 35;
      _la = this._input.LA(1);
      if (!(_la === AudienceLogicParser.AND || _la === AudienceLogicParser.OR)) {
        this._errHandler.recoverInline(this);
      } else {
        this._errHandler.reportMatch(this);
        this.consume();
      }
    } catch (re) {
      if (re instanceof antlr4.error.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  literal() {
    const localctx = new LiteralContext(this, this._ctx, this.state);
    this.enterRule(localctx, 6, AudienceLogicParser.RULE_literal);
    try {
      this.enterOuterAlt(localctx, 1);
      this.state = 37;
      this.match(AudienceLogicParser.IDENTIFIER);
    } catch (re) {
      if (re instanceof antlr4.error.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  sempred(localctx, ruleIndex, predIndex) {
    switch (ruleIndex) {
      case 1:
        return this.expression_sempred(localctx, predIndex);
      default:
        throw `No predicate with index:${ruleIndex}`;
    }
  }

  expression_sempred(localctx, predIndex) {
    switch (predIndex) {
      case 0:
        return this.precpred(this._ctx, 3);
      case 1:
        return this.precpred(this._ctx, 2);
      default:
        throw `No predicate with index:${predIndex}`;
    }
  }
}

AudienceLogicParser.EOF = antlr4.Token.EOF;
AudienceLogicParser.AND = 1;
AudienceLogicParser.OR = 2;
AudienceLogicParser.NOT = 3;
AudienceLogicParser.LPAREN = 4;
AudienceLogicParser.RPAREN = 5;
AudienceLogicParser.IDENTIFIER = 6;
AudienceLogicParser.WS = 7;

AudienceLogicParser.RULE_parse = 0;
AudienceLogicParser.RULE_expression = 1;
AudienceLogicParser.RULE_binary = 2;
AudienceLogicParser.RULE_literal = 3;

class ParseContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = AudienceLogicParser.RULE_parse;
    return this;
  }

  expression() {
    return this.getTypedRuleContext(ExpressionContext, 0);
  }

  EOF() {
    return this.getToken(AudienceLogicParser.EOF, 0);
  }

  enterRule(listener) {
    if (listener instanceof AudienceLogicListener) {
      listener.enterParse(this);
    }
  }

  exitRule(listener) {
    if (listener instanceof AudienceLogicListener) {
      listener.exitParse(this);
    }
  }
}

AudienceLogicParser.ParseContext = ParseContext;

class ExpressionContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = AudienceLogicParser.RULE_expression;
    return this;
  }

  enterRule(listener) {
    if (this.start.text === '(') {
      if (listener instanceof AudienceLogicListener) {
        listener.enterParenthesisExpression(this);
      }
    }
  }
}

class BinaryExpressionContext extends ExpressionContext {
  constructor(parser, ctx) {
    super(parser);
    this.left = null; // ExpressionContext;
    this.op = null; // Token;
    this.right = null; // ExpressionContext;
    this.copyFrom(ctx);
    return this;
  }

  expression(i) {
    if (i === undefined) {
      i = null;
    }
    if (i === null) {
      return this.getTypedRuleContexts(ExpressionContext);
    } else {
      return this.getTypedRuleContext(ExpressionContext, i);
    }
  }

  AND() {
    return this.getToken(AudienceLogicParser.AND, 0);
  }

  OR() {
    return this.getToken(AudienceLogicParser.OR, 0);
  }

  enterRule(listener) {
    if (listener instanceof AudienceLogicListener) {
      listener.enterBinaryExpression(this);
    }
  }

  exitRule(listener) {
    if (listener instanceof AudienceLogicListener) {
      listener.exitBinaryExpression(this);
    }
  }
}

AudienceLogicParser.BinaryExpressionContext = BinaryExpressionContext;

class ParenthesisExpressionContext extends ExpressionContext {
  constructor(parser, ctx) {
    super(parser);
    this.copyFrom(ctx);
    return this;
  }

  LPAREN() {
    return this.getToken(AudienceLogicParser.LPAREN, 0);
  }

  expression() {
    return this.getTypedRuleContext(ExpressionContext, 0);
  }

  RPAREN() {
    return this.getToken(AudienceLogicParser.RPAREN, 0);
  }

  enterRule(listener) {
    if (listener instanceof AudienceLogicListener) {
      listener.enterParenthesisExpression(this);
    }
  }

  exitRule(listener) {
    if (listener instanceof AudienceLogicListener) {
      listener.exitParenthesisExpression(this);
    }
  }
}

AudienceLogicParser.ParenthesisExpressionContext = ParenthesisExpressionContext;

class NotExpressionContext extends ExpressionContext {
  constructor(parser, ctx) {
    super(parser);
    this.copyFrom(ctx);
    return this;
  }

  NOT() {
    return this.getToken(AudienceLogicParser.NOT, 0);
  }

  expression() {
    return this.getTypedRuleContext(ExpressionContext, 0);
  }

  enterRule(listener) {
    if (listener instanceof AudienceLogicListener) {
      listener.enterNotExpression(this);
    }
  }

  exitRule(listener) {
    if (listener instanceof AudienceLogicListener) {
      listener.exitNotExpression(this);
    }
  }
}

AudienceLogicParser.NotExpressionContext = NotExpressionContext;

class LiteralExpressionContext extends ExpressionContext {
  constructor(parser, ctx) {
    super(parser);
    this.copyFrom(ctx);
    return this;
  }

  literal() {
    return this.getTypedRuleContext(LiteralContext, 0);
  }

  enterRule(listener) {
    if (listener instanceof AudienceLogicListener) {
      listener.enterLiteralExpression(this);
    }
  }

  exitRule(listener) {
    if (listener instanceof AudienceLogicListener) {
      listener.exitLiteralExpression(this);
    }
  }
}

AudienceLogicParser.LiteralExpressionContext = LiteralExpressionContext;

class BinaryContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = AudienceLogicParser.RULE_binary;
    return this;
  }

  AND() {
    return this.getToken(AudienceLogicParser.AND, 0);
  }

  OR() {
    return this.getToken(AudienceLogicParser.OR, 0);
  }

  enterRule(listener) {
    if (listener instanceof AudienceLogicListener) {
      listener.enterBinary(this);
    }
  }

  exitRule(listener) {
    if (listener instanceof AudienceLogicListener) {
      listener.exitBinary(this);
    }
  }
}

AudienceLogicParser.BinaryContext = BinaryContext;

class LiteralContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = AudienceLogicParser.RULE_literal;
    return this;
  }

  IDENTIFIER() {
    return this.getToken(AudienceLogicParser.IDENTIFIER, 0);
  }

  enterRule(listener) {
    if (listener instanceof AudienceLogicListener) {
      listener.enterLiteral(this);
    }
  }

  exitRule(listener) {
    if (listener instanceof AudienceLogicListener) {
      listener.exitLiteral(this);
    }
  }
}

AudienceLogicParser.LiteralContext = LiteralContext;

export { AudienceLogicParser };
